import active from "./active";

export default function*() {
    yield* [...active];
}
